import { FC } from 'react'
import { DesktopHeader } from './DesktopHeader'

export const AppHeader: FC<IAppHeader> = ({ pageName }) => {
  // NOTE: conditionally render MobileHeader here if you need
  return <DesktopHeader pageName={pageName} />
}

interface IAppHeader {
  pageName?: string
}
